export default "__VITE_ASSET__C3$b0zgc__"